// extracted by mini-css-extract-plugin
export var drawerPaper = "_1z-0";
export var itemCard = "_1z-1";
export var itemImage = "_1z-2";